import { updateToken } from './tokenSlice';
import { emptySplitApi } from './emptySplitApi';
import { Token } from '../utils/types';

export const otpService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    sendOtp: builder.mutation<{ message: string }, string>({
      query: (phoneNumber) => ({
        url: 'v2/otps',
        method: 'POST',
        data: {
          fromDevice: 2,
          mobile: phoneNumber,
          isFourDigit: true,
          communicationChannel: 1,
          clientType: 9,
          whatsAppOptIn: false,
        },
      }),
    }),
    verifyOtporToken: builder.mutation({
      query: (data) => ({
        url: 'v2/authenticate',
        method: 'POST',
        data: {
          ...data,
          clientType: 9,
        },
      }),
      async onQueryStarted(
        args,
        { dispatch, queryFulfilled }
      ) {
        queryFulfilled
          .then(({ data }: { data: Token }) => {
            localStorage.setItem(
              'authToken',
              JSON.stringify(data)
            );
            if (args.appType == 'SELLER') {
              localStorage.removeItem('isMSALUser');
            }
            dispatch(updateToken(data));
            // to-do find better way than window reload
            window.location.reload();
          })
          .catch((error) => error);
      },
    }),
  }),
});

export const {
  useSendOtpMutation,
  useVerifyOtporTokenMutation,
} = otpService;
